import React, { useContext } from 'react'
import classNames from 'classnames'
import { useNavContext } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/useNavContext'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { MenuProps } from '@toasttab/shared/src/components/organisms/Navigation/Contentful/ContentfulNavigation.d'

const MobileParentMenuLink = ({
  dropdownContent,
  heapClass,
  isMenu,
  linkUrl,
  title
}: MenuProps) => {
  const {
    isMobileNavOpen,
    selectedParentMenu,
    selectedTabbedMenu,
    setIsRegionMenuOpen,
    setSelectedParentMenu,
    setSelectedTabbedMenu
  } = useNavContext()
  const localizationContext = useContext(I18nextContext)

  const handleClick = (title: string) => {
    setIsRegionMenuOpen(false)
    if (dropdownContent?.tabbedContent) {
      setSelectedTabbedMenu(title !== selectedTabbedMenu ? title : null)
    } else {
      setSelectedParentMenu(title !== selectedParentMenu ? title : null)
    }
    const openedMenu = document.getElementById(
      `${title.replace(/\s/g, '-')}-mobile-menu`
    )

    // Find the first focusable element in the dropdown and focus on it
    const focusableElements = openedMenu?.querySelectorAll(
      'a[href], button, [tabindex]:not([tabindex="-1"])'
    )
    if (focusableElements?.length > 0) {
      setTimeout(() => {
        ;(focusableElements[0] as HTMLElement).focus()
      }, 200)
    }
  }
  const isExpanded = [selectedParentMenu, selectedTabbedMenu].includes(title)
  const subMenuCss = classNames(
    'hover:bg-neutral focus:bg-neutral border-b border-b-gray-25 border-r-4 border-r-transparent hover:border-r-blue-75 focus:border-r-blue-75',
    {
      'bg-neutral !border-r-blue-75': isExpanded
    }
  )
  const openButtonCss = classNames(
    'relative flex items-center justify-between text-left w-full p-4',
    heapClass,
    {
      'after:content-icon-chevron-right': !isExpanded
    }
  )
  if (dropdownContent?.subMenus || dropdownContent?.tabbedContent || isMenu) {
    return (
      <div
        className={subMenuCss}
        data-testid='MobileParentMenuLink'
        key={`mobile-parent-menu-${title}}`}
        role='none'
      >
        <button
          aria-controls={`${title.replace(/\s/g, '-')}-mobile-menu`}
          aria-expanded={isExpanded}
          aria-haspopup='true'
          className={openButtonCss}
          onClick={() => handleClick(title)}
          role='menuitem'
        >
          <h4 className='font-effra text-default text-[22px] leading-8'>
            {title}
          </h4>
        </button>
      </div>
    )
  } else {
    const menuHref = localizeLink(
      linkUrl,
      localizationContext.language,
      localizationContext
    )
    return (
      <div
        className='hover:bg-neutral focus:bg-neutral p-4 border-b border-b-gray-25 border-r-4 border-r-transparent hover:border-r-blue-75 focus:border-r-blue-75'
        key={`mobile-parent-link-${title}}`}
        role='none'
      >
        <a
          className={`${heapClass} relative flex items-center justify-between text-left w-full`}
          href={menuHref}
          role='menuitem'
        >
          <h4 className='font-effra text-default text-[22px] leading-8'>
            {title}
          </h4>
        </a>
      </div>
    )
  }
}

export default MobileParentMenuLink
